import { create } from "zustand"
import { devtools } from "zustand/middleware"

import { Country } from "@/types/account"
import { SnackbarProps } from "@/types/components/snackbar"
import { Unit } from "@/types/setting"
import { PositionType } from "@/types/position"

// interface CancelToken {
//   api: string
//   controller: AbortController
// }

export type GlobalState = {
  manual: {
    ko: string
    en: string
  }
  loading: boolean
  // cudToken: string[]
  // cancelToken: CancelToken[]
  // snackBar: GlobalSnackbar
  snackBar: SnackbarProps
  // confirmDialog: ConfirmDialog
  countryList: Country[]
  // positionList: Position[]
  // userRoutes: Route[]
  // flattenRoutes: Route[]
  // breadcrumbs: BreadCrumb[]
  // leftMenus: Route[]
  // footerMenus: Route[]
  // latestNotification?: Notice
  // unreadNotificationCount: number
  // metricList?: MetricMeta[]
  // unitList?: Unit[]
  // selectedUnitList?: Unit[]
  teamUnit: Unit[]
  positionList: PositionType[]
  value: number
  token: string
  // BreadCrumbs 마지막에 임시로 append 할 라벨 (path 없음 — 현재 페이지 표시용).
  // 예: 홈에서 Settings(edit) 모드 진입 시 "Home / Settings" 처럼 노출.
  trailingBreadcrumb: string | null
}

export type GlobalStore = GlobalState & GlobalStateActions

export type GlobalStateActions = {
  setSnackBar: (snackBar: SnackbarProps) => void
  setManual: (manual: { ko: string; en: string }) => void
  setLoading: (flag: boolean) => void
  setValue: (value: number) => void
  setToken: (token: string) => void
  setCountryList: (countryList: Country[]) => void
  setTeamUnit: (teamUnit: Unit[]) => void
  setPositionList: (positionList: PositionType[]) => void
  setTrailingBreadcrumb: (label: string | null) => void
}

export const defaultGlobalState: GlobalState = {
  manual: {
    ko: "",
    en: "",
  },
  countryList: [],
  loading: false,
  snackBar: {
    open: false,
    message: "",
    severity: "success",
  },
  value: 0,
  token: "",
  teamUnit: [],
  positionList: [],
  trailingBreadcrumb: null,
}

export const createGlobalStore = create<GlobalStore>()(
  devtools(
    (set) => ({
      ...defaultGlobalState,
      setSnackBar: (snackBar) => {
        set({ snackBar }, undefined, "setSnackBar")
      },
      setManual: (manual) => {
        set({ manual }, undefined, "setManual")
      },
      setLoading: (loading) => {
        set({ loading }, undefined, "setLoading")
      },
      setValue: (value) => {
        set({ value }, undefined, "setValue")
      },
      setToken: (token) => {
        set({ token }, undefined, "setToken")
      },
      setCountryList: (countryList) => {
        set({ countryList }, undefined, "setCountryList")
      },
      setTeamUnit: (teamUnit) => {
        set({ teamUnit }, undefined, "setTeamUnit")
      },
      setPositionList: (positionList) => {
        set({ positionList }, undefined, "setPositionList")
      },
      setTrailingBreadcrumb: (trailingBreadcrumb) => {
        set({ trailingBreadcrumb }, undefined, "setTrailingBreadcrumb")
      },
    }),
    {
      store: "global",
      enabled: process.env.NODE_ENV !== "production",
    },
  ),
)

export type DrawerStoreType = {
  isOpen: boolean
  isMobile: boolean
  setIsOpen: (isOpen: boolean) => void
  setIsMobile: (isMobile: boolean) => void
}

export const createDrawerStore = create<DrawerStoreType>()(
  devtools(
    (set) => ({
      isOpen: true,
      isMobile: false,
      setIsOpen: (isOpen: boolean) => set(() => ({ isOpen })),
      setIsMobile: (isMobile: boolean) => set(() => ({ isMobile })),
    }),
    {
      store: "drawer",
      enabled: process.env.NODE_ENV !== "production",
    },
  ),
)
